import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  padding: ${spacing(1, 2, 2, 2)};
`

export const headerButtons = css`
  padding-inline-end: ${spacing(2)};
`
